export const formatLabel = (string = '') => {
  const [pieces, weight] = string.split('/');

  return {
    pieces: !!pieces ? Number(pieces.replace('حقيبة', '')) : 0,
    weight: !!weight ? Number(weight.replace(' كغم', '')) : 0
  };
};

export const formatExtraBaggageList = (baggage) => {
  return baggage
    .filter(bag => Number(bag.price) > 0)
    .reduce((acc, item) => {
      const bags = Array(item.limit)
        .fill()
        .map((_, index) => ({
          ...item,
          id: index,
          isSelected: Number(index) < item.count,
          isMandatory: item.price === 0,
        }));

      return {
        ...acc,
        [item.category]: [...acc[item.category], ...bags]
      };
    }, { hold: [], carryOn: [] });
};

export const getFreeBaggage = (baggage) => {
  return {
    hold: baggage.find(bag => bag.baggageType === 'hold_bag' && Number(bag.price) === 0) || {},
    carryOn: baggage.find(bag => bag.baggageType === 'cabin_bag' && Number(bag.price) === 0) || {},
    personalItem: baggage.find(bag => bag.baggageType === 'personal_item_bag' && Number(bag.price) === 0) || {},
  };
};

export const handleChange = ({ item, baggage, extraBaggage }) => {
  return {
    baggage: baggage.map(bag => bag.reference === item.reference
      && bag.category === item.category
      ? { ...bag, count: item.isSelected ? bag.count + 1 : bag.count - 1 } : bag
    ),
    extraBaggage: {
      ...extraBaggage,
      [item.category]: extraBaggage[item.category]
        .map(bag => bag.reference === item.reference
          && bag.id === item.id
          ? item : bag
        )
    }
  };
};